const convertStringToInteger = (string) => {
  return string.replace(/\D/g, '')
}

export default convertStringToInteger
